<router-outlet></router-outlet>
<ngx-sonner-toaster position="top-center" richColors />
